import React, { useCallback, useContext, useEffect, useMemo, useState } from 'react';

export interface IResponsiveContext {
  showSidebar: boolean;
  horizontalBtnAlignment: boolean;
  useSmallFormImages: boolean;
}

const ResponsiveContext = React.createContext<IResponsiveContext>({
  showSidebar: true,
  horizontalBtnAlignment: false,
  useSmallFormImages: false,
});

export function useResponsiveContext() {
  return useContext(ResponsiveContext);
}

export const ResponsiveProvider: React.FC<any> = ({ children }): JSX.Element => {
  const [responsiveContext, setResponsiveContext] = useState<IResponsiveContext>({
    showSidebar: true,
    horizontalBtnAlignment: false,
    useSmallFormImages: false,
  });

  const updateUi = useCallback(() => {
    const ratio = window.innerWidth / window.innerHeight;
    const ratio4x3 = 4 / 3;
    const ratioPadding = ratio4x3 / 100; // 10% ratio padding
    if (ratio >= ratio4x3 - ratioPadding && ratio <= ratio4x3 + ratioPadding) {
      setResponsiveContext({
        showSidebar: false,
        horizontalBtnAlignment: true,
        useSmallFormImages: true,
      });
    } else {
      setResponsiveContext({
        showSidebar: true,
        horizontalBtnAlignment: false,
        useSmallFormImages: false,
      });
    }
  }, [setResponsiveContext]);

  useEffect(() => {
    if (window) {
      updateUi();
      window.addEventListener('resize', updateUi);
    }
  }, [updateUi]);

  const memoizedValue = useMemo(() => responsiveContext, [responsiveContext]);

  return <ResponsiveContext.Provider value={memoizedValue}>{children}</ResponsiveContext.Provider>;
};
